/**
 * Initial state factory for the "siwfauth" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `siwfData` holds the "Sign In
 * With Farcaster" data for the current session, or `null` when unset.
 */
export default () => ({
  siwfData: null,
});
